import { useNavigate } from 'react-router-dom';
import { ImageOff } from 'lucide-react';
import { haptic } from '../lib/tma';
import { cn } from '../lib/cn';

export interface IdeaCardProps {
  idea: { id: number; title: string; thumbnail_url: string; matryoshka: string };
  onClick?: () => void;
}

export function IdeaCard({ idea, onClick }: IdeaCardProps) {
  const navigate = useNavigate();

  function handleClick() {
    haptic('light');
    if (onClick) {
      onClick();
    } else {
      navigate(`/ideas/${idea.id}`);
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        'group flex flex-col text-left rounded-2xl overflow-hidden bg-tg-section-bg',
        'transition-[transform,opacity] duration-150 ease-smooth',
        'active:scale-[0.98] active:opacity-90',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-tg-bg',
      )}
    >
      <div className="aspect-square bg-tg-section-bg overflow-hidden relative">
        {idea.thumbnail_url ? (
          <img
            src={idea.thumbnail_url}
            alt={idea.title}
            className="w-full h-full object-cover transition-transform duration-200 group-active:scale-[1.02]"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-tg-hint">
            <ImageOff size={28} aria-hidden />
          </div>
        )}
      </div>
      <div className="p-3">
        <div className="text-sm font-semibold line-clamp-2 leading-snug">{idea.title}</div>
        <div className="mt-1.5 text-[11px] text-tg-hint font-medium">{idea.matryoshka}</div>
      </div>
    </button>
  );
}
